<template>
  <div class="border radius-12 px-3 pt-3 pb-2 cursor-pointer" @click="whatsappLink()" v-if="getMerchant().whatsapp_number != ''">
    <div class="row no-gutters">
      <div class="col-11">
        <div class="d-inline-block mr-2 pr-1 position-relative" style="top:-12px">
          <svg width="36" class="mt-1" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30.375 0H5.625C2.5184 0 0 2.5184 0 5.625V30.375C0 33.4816 2.5184 36 5.625 36H30.375C33.4816 36 36 33.4816 36 30.375V5.625C36 2.5184 33.4816 0 30.375 0Z" fill="#25D366"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M25 10.875C23.125 9 20.625 8 18 8C12.5 8 8 12.5 8 18C8 19.75 8.50001 21.5 9.37501 23L8 28L13.25 26.625C14.75 27.375 16.375 27.875 18 27.875C23.5 27.875 28 23.375 28 17.875C28 15.25 26.875 12.75 25 10.875ZM18 26.25C16.5 26.25 15 25.875 13.75 25.125L13.5 25L10.375 25.875L11.25 22.875L11 22.5C10.125 21.125 9.74999 19.625 9.74999 18.125C9.74999 13.625 13.5 9.875 18 9.875C20.25 9.875 22.25 10.75 23.875 12.25C25.5 13.875 26.25 15.875 26.25 18.125C26.25 22.5 22.625 26.25 18 26.25ZM22.5 20C22.25 19.875 21 19.25 20.75 19.25C20.5 19.125 20.375 19.125 20.25 19.375C20.125 19.625 19.625 20.125 19.5 20.375C19.375 20.5 19.25 20.5 19 20.5C18.75 20.375 18 20.125 17 19.25C16.25 18.625 15.75 17.75 15.625 17.5C15.5 17.25 15.625 17.125 15.75 17C15.875 16.875 16 16.75 16.125 16.625C16.25 16.5 16.25 16.375 16.375 16.25C16.5 16.125 16.375 16 16.375 15.875C16.375 15.75 15.875 14.5 15.625 14C15.5 13.625 15.25 13.625 15.125 13.625C15 13.625 14.875 13.625 14.625 13.625C14.5 13.625 14.25 13.625 14 13.875C13.75 14.125 13.125 14.75 13.125 16C13.125 17.25 14 18.375 14.125 18.625C14.25 18.75 15.875 21.375 18.375 22.375C20.5 23.25 20.875 23 21.375 23C21.875 23 22.875 22.375 23 21.875C23.25 21.25 23.25 20.75 23.125 20.75C23 20.125 22.75 20.125 22.5 20Z" fill="white"/>
          </svg>
        </div>
        <div class="d-inline-block">
          <p class="mb-0 heading-5 text-black text-15">{{$t('hotel.concierge.fitur.have-a-question')}}</p>
          <p class="mb-0 body-2-2-1 text-black text-13">{{description}}</p>
        </div>
      </div>
      <div class="col-1 text-right position-relative">
        <svg width="14" class="position-relative" style="top:17%" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.51844 11.526C4.34457 11.3556 4.32877 11.0888 4.47102 10.9009L4.51844 10.847L8.44283 6.99996L4.51844 3.15289C4.34457 2.98244 4.32877 2.71572 4.47102 2.52776L4.51844 2.47391C4.69231 2.30346 4.96438 2.28797 5.15611 2.42743L5.21104 2.47391L9.48156 6.66047C9.65543 6.83092 9.67123 7.09765 9.52898 7.2856L9.48156 7.33945L5.21104 11.526C5.01978 11.7135 4.7097 11.7135 4.51844 11.526Z" fill="#AAAAAA"/>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  export default{
    props: ['name','description'],
    mounted(){
      this.currentLink()
    },
    methods:{
      ...mapGetters(['getMerchant']),
      currentLink(){
        return window.location.href
      },
      whatsappLink(){
        window.location.href = 'https://api.whatsapp.com/send?phone='+this.getMerchant().whatsapp_number+'&text=Hello%2C%20I%20want%20to%20ask%20about.%0A'+this.name+'%0A'+this.currentLink()+'.'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/whatsappLink.vue